import { Trans } from "@lingui/react";
import { useResolvedCompanyCtx } from '@contexts/ResolvedCompanyContext/ResolvedCompanyProvider';
import * as React from 'react';
import { Button } from '~ui/components/buttons/Button/Button';
import { Carousel } from '~ui/components/content/Carousel/Carousel';
import { Text } from '~ui/components/typography/Text/Text';
import { useLayoutIsXS } from '../../Responsive/client';
import { GuideOverlayDrawer } from './GuideOverlayDrawer';
import { GuideOverlayModal } from './GuideOverlayModal';
import { OrderButton } from './OrderButton';
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * Overlay for the guide.
 * It renders the drawer for mobile and the modal for tablet/desktop.
 * It displays the guide instructions in a carousel.
 */
export var GuideOverlay = function GuideOverlay(_ref) {
  var isOpen = _ref.isOpen,
      onClose = _ref.onClose;
  var isMobile = useLayoutIsXS();

  var _useResolvedCompanyCt = useResolvedCompanyCtx(),
      resolvedBranch = _useResolvedCompanyCt.resolvedBranch;

  var OverlayComponent = React.useMemo(function () {
    return isMobile ? GuideOverlayDrawer : GuideOverlayModal;
  }, [isMobile]); // renders the navigation buttons for the Carousel based on the type (previous/next)

  var renderNavButton = function renderNavButton(_ref2) {
    var isDisabled = _ref2.isDisabled,
        onClick = _ref2.onClick,
        type = _ref2.type;
    var state = isDisabled ? "disabled" : undefined;
    var padding = {
      horizontal: "mediumLarge",
      vertical: "smallMedium"
    };
    var label = type === "next" ? /*#__PURE__*/_jsx(Trans, {
      id: "hXzOVo"
    }) : /*#__PURE__*/_jsx(Trans, {
      id: "DHhJ7s"
    });
    return /*#__PURE__*/_jsx(Button, {
      state: state,
      padding: padding,
      onClick: onClick,
      children: /*#__PURE__*/_jsx(Text, {
        children: label
      })
    });
  };

  return /*#__PURE__*/_jsx(OverlayComponent, {
    footerContent: /*#__PURE__*/_jsx(OrderButton, {}),
    isOpen: isOpen,
    onClose: onClose,
    children: /*#__PURE__*/_jsx(Carousel, {
      isMobile: isMobile,
      items: resolvedBranch.instructions,
      navigationProps: {
        bgColorNavCircle: "secondary",
        bgColorSelected: "primary",
        renderNavButton: renderNavButton
      }
    })
  });
};